import React, { useState, useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import QuestionBox from "../../questions";

import Topics from "../../topics";
import Subjects from "../../subjects";
import { Topic, Subject, LevelData } from "../../types";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

const get_levels = gql`
  query GetLevels {
    getLevels {
      levelId
      name
      subjects {
        subjectId
        name
      }
    }
  }
`;

const get_topics = gql`
  query GetTOpics($levelId: ID!, $subjectId: ID!) {
    getTopics(levelId: $levelId, subjectId: $subjectId) {
      name
      description
      resources {
        embedId
        title
        description
      }
    }
  }
`;

const GradePanel = () => {
  const { loading, error, data } = useQuery(get_levels);

  const [value, setValue] = useState(0);

  const [disableSubmit, setDisableSubmit] = useState(false);
  const [levelsData, setLevelsData] = useState<LevelData[]>();
  const [selLevelId, setSelLevelId] = useState("K");
  const [selectedLevel, setSelectedLevel] = useState(data?.getLevels[0]);
  const [selSubjectId, setSelSubjectId] = useState("math");

  const {
    loading: loadingTopics,
    error: errorTopics,
    data: dataTopics,
  } = useQuery(get_topics, {
    variables: { levelId: selLevelId, subjectId: selSubjectId },
  });

  const [currentTopic, setCurrentTopic] = useState(dataTopics?.getTopics[0]);

  useEffect(() => {
    if (data?.getLevels.length > 0) setLevelsData(data?.getLevels);
    setSelectedLevel(data?.getLevels[0]);
  }, [data]);

  useEffect(() => {
    if (dataTopics?.getTopics.length > 0)
      setCurrentTopic(dataTopics.getTopics[0]);
  }, [dataTopics]);

  const handleSelection = (level: any) => {
    setSelectedLevel(level);
    setSelLevelId(level.levelId);
  };

  const reset = () => {
    setDisableSubmit(false);
  };

  // if (loading) console.log(loading);
  // if (error) console.log(error);
  // if (data) console.log("levels data", data);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  };

  return (
    <>
      <Box
        component="section"
        id="section1"
        sx={{
          display: "flex",

          alignItems: "left",
          justifyContent: "left",
          flexDirection: "column",
          paddingLeft: "12rem",
          paddingRight: "6rem",
        }}
      >
        <Typography
          variant="h4" // Adjust the size as needed
          component="h2"
          sx={{
            fontWeight: "bold",
            color: "#1A202C", // Adjust the color to match the image
          }}
        >
          Grade Levels
        </Typography>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#000000",
            },
          }}
          textColor="inherit"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          style={{
            width: "90%",
          }}
        >
          {data?.getLevels?.map((level: any, index: number) => {
            return (
              <Tab
                key={index}
                label={`Level ${index}`}
                onClick={() => handleSelection(level)}
              />
            );
          })}
        </Tabs>
        {data?.getLevels.map((level: LevelData, index: number) => {
          return (
            <TabPanel value={value} index={index}>
              {/* <Subjects
                level={selectedLevel}
                selectSubject={(val: Subject) => {
                  setSelSubjectId(val.subjectId);
                }}
              /> */}

              <Topics
                level={selectedLevel}
                topics={dataTopics}
                selectTopic={(val: Topic) => {
                  setCurrentTopic(val);
                }}
              />
              <QuestionBox
                levelId={selectedLevel?.levelId}
                subjectId={selSubjectId}
                topic={currentTopic}
                disableSubmit={disableSubmit}
                reset={reset}
              />
            </TabPanel>
          );
        })}
      </Box>
    </>
  );
};

export default GradePanel;
